import { restaurant } from "../data/menu";

export default function Localisation() {
  return (
    <section
      id="localisation"
      data-testid="location-section"
      className="relative py-24 lg:py-32 bg-[#f6efe2]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-5 gap-12 items-start">
        <div className="lg:col-span-2 lg:sticky lg:top-32">
          <p className="text-xs uppercase tracking-[0.32em] text-[#c23b22] mb-4">
            <i className="fa-solid fa-location-dot mr-2" />
            Venez nous voir
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#1a1a1a] leading-tight">
            Place Carnot,
            <br />
            <em className="italic text-[#2d4a22]">au cœur de Mamers.</em>
          </h2>
          <p className="mt-6 text-[#5c5c5c] text-base sm:text-lg leading-relaxed">
            Sur place ou à emporter. Pour passer commande, un seul numéro.
          </p>

          <div className="mt-10 space-y-5 text-[#1a1a1a]">
            <div className="flex items-start gap-4">
              <span className="shrink-0 w-10 h-10 rounded-full bg-white border border-[#e5e0d5] inline-flex items-center justify-center text-[#c23b22]">
                <i className="fa-solid fa-location-dot" />
              </span>
              <div>
                <p className="text-xs uppercase tracking-[0.22em] text-[#5c5c5c]">
                  Adresse
                </p>
                <p className="mt-1 font-serif text-xl">
                  {restaurant.address}
                </p>
                <p className="text-[#5c5c5c]">{restaurant.city}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="shrink-0 w-10 h-10 rounded-full bg-white border border-[#e5e0d5] inline-flex items-center justify-center text-[#c23b22]">
                <i className="fa-solid fa-phone" />
              </span>
              <div>
                <p className="text-xs uppercase tracking-[0.22em] text-[#5c5c5c]">
                  Téléphone
                </p>
                <a
                  href={`tel:${restaurant.phoneRaw}`}
                  data-testid="location-phone-link"
                  className="mt-1 font-serif text-2xl text-[#c23b22] hover:underline"
                >
                  {restaurant.phone}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <span className="shrink-0 w-10 h-10 rounded-full bg-white border border-[#e5e0d5] inline-flex items-center justify-center text-[#c23b22]">
                <i className="fa-brands fa-facebook" />
              </span>
              <div>
                <p className="text-xs uppercase tracking-[0.22em] text-[#5c5c5c]">
                  Facebook
                </p>
                <a
                  href={`https://www.facebook.com/${restaurant.facebook}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="location-facebook"
                  className="mt-1 inline-block text-[#1a1a1a] hover:text-[#c23b22]"
                >
                  @{restaurant.facebook}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="rounded-2xl overflow-hidden border border-[#e5e0d5] shadow-lg bg-white">
            <iframe
              data-testid="location-map"
              title="Carte Piccola Venezia Mamers"
              src="https://www.google.com/maps?q=22+rue+Chevalier,+72600+Mamers,+France&output=embed"
              className="w-full h-[500px] lg:h-[640px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
